import { Component, OnInit } from '@angular/core';
import { AuthWebService } from 'app/services/authweb.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.css']
})
export class ActivateAccountComponent implements OnInit {
  public isLoading = false;

  constructor(public authWebService: AuthWebService,private router: Router,private route: ActivatedRoute) { }

  ngOnInit() {
    this.activate();
  }
activate(){
  // this.isLoading = true;
  // this.authWebService.activateAccout(localStorage.getItem('activeEmail'))
  // this.isLoading = false;
  //console.log('from activate')
  this.route.params.subscribe(params => {
    //console.log(params.id)

    this.authWebService.activateAccout(params.id)

      })

}
}
